// extracted by mini-css-extract-plugin
module.exports = {"course-card__container":"CourseDetails_course-card__container__E4IWy","is-not-clickable":"CourseDetails_is-not-clickable__z_XQN"};